import Turnstile from 'react-turnstile';

type Props = {
  onVerify: (token: string) => void;
  onError?: (error: Error | any) => void;
  onLoad?: () => void;
  onExpire?: (token: string) => void;
  onTimeout?: () => void;
};

const CloudflareTurnstile = ({
  onVerify,
  onError,
  onLoad,
  onExpire,
  onTimeout,
}: Props) => {
  const sitekey = process.env.NEXT_PUBLIC_TURNSTILE_SITEKEY || '';
  const enabled = Boolean(sitekey);

  if (!enabled) {
    return null;
  }

  return (
    <Turnstile
      sitekey={sitekey}
      onVerify={onVerify}
      onError={onError}
      onLoad={onLoad}
      onExpire={onExpire}
      onTimeout={onTimeout}
      refreshExpired="auto"
    />
  );
};

export default CloudflareTurnstile;
